import React from 'react';
import Linkify from 'react-linkify';

import UserGeneratedLink from 'buyside/components/presentation/UserGeneratedLink/UserGeneratedLink';

import { formatLineBreaks } from 'buyside/util/userInputHelper';
import { userUrl, employerProfileUrl, entityUrl, userIdeaUrl } from 'buyside/util/urlHelper';

const CommentBodyRenderer = ({ body }) => {
  return (
    <Linkify
      componentDecorator={(decoratedHref, decoratedText, key) => {
        return (
          <UserGeneratedLink href={decoratedHref} key={key}>
            {decoratedText}
          </UserGeneratedLink>
        );
      }}
    >
      {body
        .replace(/@\[[^\]]*\]\([^)]*\)/g, match => {
          return `,,${match},,`;
        })
        .replace(/\$\[[^\]]*\]\([^)]*\)/g, match => {
          return `,,${match},,`;
        })
        .split(',,')
        .map((result, idx) => {
          const matches =
            result.match(/@\[[^\]]*\]\([^)]*\)/) || result.match(/\$\[[^\]]*\]\([^)]*\)/);
          if (matches) {
            const match = matches[0];

            //http://stackoverflow.com/questions/3569104/positive-look-behind-in-javascript-regular-expression
            //capturing groups seem to work
            const symbol = match.match(/\(([^\)]+)\)$/)[1];
            let display = match.match(/\[([^\]]+)\]/)[1];
            const userIdentifier = symbol.split('-');
            let route;

            // if (userIdentifier[0] === 'User') {
            //   route = userUrl(userIdentifier[1]);
            // } else if ()
            switch (userIdentifier[0]) {
              case 'AnonUser':
                route = userIdeaUrl(encodeURI(userIdentifier[1]));
                break;
              case 'User':
                route = userUrl(userIdentifier[1]);
                break;
              case 'Employer':
                route = employerProfileUrl(userIdentifier[1]);
                break;
              case 'Asset':
                route = entityUrl(userIdentifier[3]);
                display = display.substr(0, display.lastIndexOf(':'));
                break;
              default:
                route = '#';
            }
            if (userIdentifier[1] === '10050') route = '#';

            return (
              <a key={`${idx}-${symbol}`} href={route} style={{ color: '#4A90E2' }}>
                {userIdentifier[0] === 'Asset' && '$'}
                {display}
              </a>
            );
          } else {
            return formatLineBreaks(result, idx);
          }
        })}
    </Linkify>
  );
};

export default CommentBodyRenderer;
